//react
import React from "react";

//router
//import { Redirect } from "react-router-dom";

//redux
import { connect } from 'react-redux'

// styles
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";

import Parallax from "components/Parallax/Parallax.jsx";
//import logo from "assets/img/logo.png"
//import coverPhoto from "assets/img/kids13.jpg"; 
import coverPhoto from "assets/img/greetings1.png";

import landingPageStyle from "assets/jss/material-kit-pro-react/views/landingPageStyle.jsx";

const dashboardRoutes = [];

class GetStartedPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  render() {
    const { classes, ...rest } = this.props;
    
    return (

      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="All Things EQ"
          links={<HeaderLinks />}
          fixed 
          changeColorOnScroll={{
            height: 200,
            color: "dark"
          }} 
          {...rest}
        />
        <div style={{backgroundImage:"linear-gradient(black, white)"}}>
          <Parallax image={coverPhoto} filter="dark">
            <div className={classes.container} style={{position: "static", marginBottom:"89px"}}>
              <GridContainer style={{textAlign: "center"}}>
                <GridItem xs={12} sm={12} md={12}>
                  <br />Let's Get Started
                </GridItem>
                <br /><br />
              </GridContainer>
            </div>
          </Parallax>
          
          <div className={classNames(classes.main, classes.mainRaisedHigh)} style={{backgroundColor:"#efefef", marginTop:"-369px", marginLeft:"10px", marginRight:"10px", borderRadius:"6px", minHeight:"500px"}}>
            <div className={classes.container}>
              
              <div className={classes.section} >

                  <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                          
                          <br />

                          <h3 style={{color:"black"}} classes={[classes.title, classes.black]}>Get Started</h3>

                        
                          <br /><br />
                      </GridItem>
                  </GridContainer>
              </div>
            </div>
          </div>

        </div>
        <Footer content={
            <div>
              <div className={classes.left}>
                <List className={classes.list}>
                  <ListItem className={classes.inlineBlock}>
                    <a
                      href="https://app.allthingseq.com/"
                      className={classes.block}
                    >
                      All Things E.Q.
                    </a>
                  </ListItem>
                  
                </List>
              </div>
              <div className={classes.right} style={{fontSize:"12px", marginRight:"23px"}}>
                &copy; {1900 + new Date().getYear()}{" "}
                AVA School Solutions
              </div>
            </div>
          }/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
}
GetStartedPage = connect(mapStateToProps)(GetStartedPage);
export default withStyles(landingPageStyle)(GetStartedPage);


// WEBPACK FOOTER //
// ./src/views/GetStartedPage/GetStartedPage.jsx